import { createSelector } from 'reselect'

const _getAsanaIntegrations = (state) => state.integrations?.asanaIntegrations

export const getInvalidAsanaIntegrations = createSelector([_getAsanaIntegrations], (asanaIntegrations) => {
  if (!asanaIntegrations) return []

  return asanaIntegrations.filter((asanaIntegration) => asanaIntegration.areCredentialsInvalid)
})
